import "./styles.css";
import { UseFormReturn } from "react-hook-form";
import { handleKeyDown } from "../../../utils/projectInternal";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { ProjectDescriptionFormProps } from "../../../pages/Projects/InternalProjectsTabs/Interfaces/InternalProjectsFormProps";
import { useParams } from "react-router-dom";
import { PutProjectDescriptionAPI } from "../../../API/InternalProjectsAPI";
import { toast } from "react-toastify";
import { IResponseProps } from "../../../interfaces/IResponseProps";
import { ReactNode, useEffect, useState } from "react";
import { ButtonSubmitDefault } from "../../Shared/ButtonSubmitDefault/ButtonSubmitDefault";
import { TypographyCustom } from "../../Shared/InternalProjects/TypographyCustom/TypographyCustom";
import { fieldsAllTypes, fieldsProfessionalTrainingAndQualification } from "../../../Static/ProjectDescriptionStatic";
import { Tooltip } from 'antd';
import { AiFillInfoCircle } from "react-icons/ai";

export interface IProjectDescriptionFormProps {
    projectDescriptionTabForm: UseFormReturn<ProjectDescriptionFormProps, any>
}
export interface IFieldProps {
    id: number,
    field: string,
    label: string,
    tooltip: ReactNode,
}
export interface IFieldComponentProps {
    id: number,
    title: string,
    subTitle: string,
    list: IFieldProps[],
    tooltip?: ReactNode,
}

export function ProjectDescriptionTab({ projectDescriptionTabForm }: IProjectDescriptionFormProps) {
    const { register, handleSubmit, control, formState: { errors }, getValues, setValue, watch } = projectDescriptionTabForm;
    const { id, typology } = useParams();
    const [loading, setLoading] = useState(false);
    const [fields, setFields] = useState<IFieldComponentProps[]>(fieldsAllTypes);

    console.log('erros: ', errors);

    useEffect(() => {
        (typology !== "5")
            ? setFields(fieldsAllTypes)
            : setFields(fieldsProfessionalTrainingAndQualification)
    }, [fields])

    async function handleUpdateProject(data: ProjectDescriptionFormProps) {
        setLoading(true);
        try {
            data.id = id ?? "00000000-0000-0000-0000-000000000000";

            await PutProjectDescriptionAPI(data).then((resp: IResponseProps) => {

                resp.statusCode === 200
                    ? toast.success('Projeto editado com sucesso')
                    : toast.error('Erro ao editar projeto.');
            });
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            setLoading(false);
        }
    }
    return (
        <>
            <div className="card">
                <form className="card-body" onSubmit={handleSubmit(handleUpdateProject)} onKeyDown={handleKeyDown}>
                    <div className="mb-4">
                        {fields.map((data, index) => {
                            console.log(data.tooltip)
                            return (
                                <Accordion key={index} className="mt-4">
                                    <div className="text-title">

                                        <AccordionSummary aria-controls="panel8d-content" id="panel8d-header" expandIcon={<ExpandMore />}>
                                            <Typography>{data.title}
                                            </Typography>
                                            {/* mudar tooltip, esta em descrição e ter que ir para cadasubtitulo */}
                                        </AccordionSummary>


                                    </div>
                                    <AccordionDetails>
                                        <Typography className="font-weight-bold">
                                            {data.subTitle}
                                            <Tooltip title={data.tooltip}><AiFillInfoCircle size={15} className="ms-1 info-color" style={{ fontSize: '24px', cursor: 'pointer' }} /></Tooltip>
                                        </Typography>

                                        {data.list.map((p, i) => {
                                            return (
                                                <TypographyCustom
                                                    key={i}
                                                    field={p.field}
                                                    label={p.label}
                                                    register={register}
                                                    getValues={getValues}
                                                    tooltip={p.tooltip}
                                                />
                                            )
                                        })}
                                    </AccordionDetails>
                                </Accordion>
                            )
                        })}
                    </div>

                    {id != null && <ButtonSubmitDefault type="submit" />}
                </form >
            </div >
        </>
    )

}